import * as yup from 'yup';

export type DocumentRequirement = {
  entityToken: string;
  entityName: string;
  documentName: string;
};

type DocumentUploadProgress = {
  progress: number;
  progressComputable: boolean;
  uploading: boolean;
};

export type DocumentUploadState = DocumentRequirement &
  DocumentUploadProgress & {
    file: File | null;
  };

const requiredDocumentValidationSchema = yup.object({
  file: yup.mixed().nullable().required('Please upload this document to continue.'),
});

export const requiredDocumentsValidationSchema = yup.object({
  documents: yup.array(requiredDocumentValidationSchema),
});

export const MAX_FINANCIAL_DOCUMENTS = 20;
export const MAX_FINANCIAL_DOCUMENT_SIZE_MB = 50;
export const MAX_FINANCIAL_DOCUMENT_SIZE_BYTES = MAX_FINANCIAL_DOCUMENT_SIZE_MB * 1024 * 1024;
